// extracted by mini-css-extract-plugin
export var errorsContainer = "_uy-1";
export var link = "_uy-0";